export default class ResendGiftModel {
    constructor() {
        this.Email = ""
        this.GiftClientID = ""
        this.GiftID = ""
        this.TwitterID = ""
        this.DeliveryBy = 1
    }
}